import { make } from 'redux-chill';

const resetDeliveryPage = make('[delivery] reset delivery page').stage(
  (_: void) => ({})
);

export { resetDeliveryPage };
